module.exports = __webpack_public_path__ + "static/media/infoJumbo1.ce124d3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/fetzer/images/infoJumbo1.jpg
// module id = 490
// module chunks = 0